import createIcon from '../../createIcon';

/**
 * @component @name MarkUnreadChatAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgN0MyMC42NTY5IDcgMjIgNS42NTY4NSAyMiA0QzIyIDIuMzQzMTUgMjAuNjU2OSAxIDE5IDFDMTcuMzQzMSAxIDE2IDIuMzQzMTUgMTYgNEMxNiA1LjY1Njg1IDE3LjM0MzEgNyAxOSA3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTYgOVY3SDE1LjAzQzEzLjgyIDUuNCAxMy45NSAzLjc5IDE0LjExIDNINC4wMUMyLjkxIDMgMi4wMSAzLjg5IDIuMDEgNUwyIDIzTDYgMTlIMjBDMjEuMSAxOSAyMiAxOC4xIDIyIDE3VjcuOTdDMjEuMTYgOC42MSAyMC4xMyA5IDE5IDlINlpNMTQgMTVINlYxM0gxNFYxNVpNMTggMTJINlYxMEgxOFYxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MarkUnreadChatAlt = createIcon('MarkUnreadChatAlt', [
  [
    'path',
    {
      d: 'M19 7C20.6569 7 22 5.65685 22 4C22 2.34315 20.6569 1 19 1C17.3431 1 16 2.34315 16 4C16 5.65685 17.3431 7 19 7Z',
      key: '1ewe21',
    },
  ],
  [
    'path',
    {
      d: 'M6 9V7H15.03C13.82 5.4 13.95 3.79 14.11 3H4.01C2.91 3 2.01 3.89 2.01 5L2 23L6 19H20C21.1 19 22 18.1 22 17V7.97C21.16 8.61 20.13 9 19 9H6ZM14 15H6V13H14V15ZM18 12H6V10H18V12Z',
      key: 'zxi0m9',
    },
  ],
]);

export default MarkUnreadChatAlt;
